import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { statsConfigSelectors } from '~/redux/ducks/config';
import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

const DecisionSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setDecision = (e, { value }) => {
        dispatch(filterActionCreators.setDecision(value));
    };

    const statsConfig = useSelector((state) => state.config);
    const selectedDecision = useSelector((state) => state.playersAndTeams.filter.values.decision);
    const report = useSelector(
        (state) => state.playersAndTeams.report.current,
        (current, previous) =>
            current.dateFrom === previous.dateFrom &&
            current.dateTo === previous.dateTo &&
            current.seasonFrom === previous.seasonFrom &&
            current.seasonTo === previous.seasonTo &&
            current.isDateRangeFromSeasons === previous.isDateRangeFromSeasons,
    );

    const genDecisionOptions = () => {
        const decisions = statsConfigSelectors
            .getListOfThingsForReport(statsConfig, report, 'gameResults')
            .map((result) => ({
                value: result,
                label: intl.formatMessage(commonMessages.gameResultValues[result]),
                key: result,
            }));

        return [{ value: '', label: intl.formatMessage(commonMessages.gameResultValues.a), key: '' }, ...decisions];
    };

    const options = genDecisionOptions();
    const value = options.find((obj) => obj.value === selectedDecision);

    if (!value) {
        setDecision(undefined, { value: '' });
    }

    return (
        <Select
            onOptionChange={setDecision}
            options={options}
            selectedOption={value}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(DecisionSelect);
